import * as yup from 'yup';

import i18n from '@app/i18n/config';

import { RECORDS_PER_FORM_MAX, RECORDS_PER_FORM_MIN } from '../../constants';
import { stringSchema } from '../../helpers';

const companyRequiredMessage = i18n.t(
  'REGISTRATION_QUESTIONARY:insuranceAgentExperienceListForm.errors.companyRequired'
);
const dateRequiredMessage = i18n.t(
  'REGISTRATION_QUESTIONARY:insuranceAgentExperienceListForm.errors.dateRequired'
);
const dateRangeMessage = i18n.t(
  'REGISTRATION_QUESTIONARY:insuranceAgentExperienceListForm.errors.dateRange'
);
const dateOrderMessage = i18n.t(
  'REGISTRATION_QUESTIONARY:insuranceAgentExperienceListForm.errors.dateOrder'
);

const minCooperationDate = new Date(1950, 0, 1);

const isValidDate = (value?: string) => {
  if (!value) return true;

  const date = new Date(value);
  const currentDate = new Date();
  const dateMonth = new Date(date.getFullYear(), date.getMonth(), 1);
  const currentMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );

  return (
    !Number.isNaN(date.getTime()) &&
    dateMonth >= minCooperationDate &&
    dateMonth <= currentMonth
  );
};

const cooperationDateSchema = yup
  .string()
  .test('date-range', dateRangeMessage, isValidDate);

export const insuranceAgentExperienceListFormSchema = yup
  .object({
    insuranceAgentWorkDetails: yup
      .array()
      .of(
        yup
          .object({
            companyName: stringSchema(companyRequiredMessage),
            startDate: cooperationDateSchema.required(dateRequiredMessage),
            endDate: cooperationDateSchema
              .when('isCurrentJob', ([isCurrentJob], schema) =>
                isCurrentJob ? schema : schema.required(dateRequiredMessage)
              )
              .test('date-order', dateOrderMessage, function (endDate) {
                const { isCurrentJob, startDate } = this.parent;

                if (isCurrentJob || !startDate || !endDate) return true;

                const start = new Date(startDate);
                const end = new Date(endDate);

                if (
                  Number.isNaN(start.getTime()) ||
                  Number.isNaN(end.getTime())
                ) {
                  return true;
                }

                return (
                  new Date(end.getFullYear(), end.getMonth(), 1) >=
                  new Date(start.getFullYear(), start.getMonth(), 1)
                );
              }),
            isCurrentJob: yup.boolean().required(dateRequiredMessage),
          })
          .required()
      )
      .required(dateRequiredMessage)
      .min(RECORDS_PER_FORM_MIN, dateRequiredMessage)
      .max(RECORDS_PER_FORM_MAX),
  })
  .required();
